// apiMixin.js
import Vue from 'vue';
import axios from 'axios';
import {mapMutations} from 'vuex';
import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';

Vue.use(VueToast, {
    // One of the options
    position: 'top-right'
});
//Vue.$toast.open({/* options */});

export default {
    data() {
        return {
            apiLoading: false,
            apiError: null,
        };
    },
    methods: {
        ...mapMutations(['setCsrfToken']),
        async fetchCsrfToken() {
            try {
                const response = await axios.get('/api/csrf');
                const token = response.data.token;
                this.setCsrfToken(token); // Commit the token to Vuex store
            } catch (error) {
                console.error('Failed to fetch CSRF token', error);
            }
        },
        callApi(method, url, data, params = [], showToast = false, axiosConfig = {}) {
            return new Promise(async (resolve, reject) => {
                this.apiLoading = true;
                this.apiError = null;
                try {
                    if (!params.hasOwnProperty('headers')) params.headers = [];
                    if (method !== 'get') params.headers['X-CSRF-TOKEN'] = this.$store.state.csrfToken;

                    const response = await axios({
                        method: method,
                        url: url,
                        data: data,
                        params: params,
                        ...axiosConfig,
                    });
                    //
                    if (response.data && response.data.status) {
                        if (showToast) {
                            Vue.$toast.success(response.data.message)
                        }
                        resolve(response.data.data)
                    } else {
                        if (response && response.status === 419) {
                            // CSRF token mismatch, refetch the token and retry the API call
                            await this.fetchCsrfToken();
                            await this.callApi();
                        }

                        Vue.$toast.error(response.data.message)
                        reject(response)
                    }
                } catch (error) {
                    if (error.response && error.response.data) {
                        Vue.$toast.error(error.response.data.message)
                    } else {
                        Vue.$toast.error(error.message)
                    }
                    reject(error)
                } finally {
                    this.apiLoading = false;
                }
            })
        },
        post(url, data, showToast = true) {
            return this.callApi('post', url, data, [], showToast);
        },
        postForm(url, data, showToast = true) {
            return this.callApi('post', url, data, [], showToast);
        },
        put(url, data, showToast = false) {
            return this.callApi('put', url, data, [], showToast);
        },
        patch(url, data, showToast = false) {
              return this.callApi('patch', url, data, [], showToast);
        },
        delete(url, showToast = true) {
            return this.callApi('delete', url, [], [], showToast);
        },
        get(url, params = {}, showToast = false) {
            return this.callApi('get', url, [], params, showToast);
        },
        postWithProgress(url, data, onUploadProgress, showToast = false, signal = null) {
            const config = { onUploadProgress };
            if (signal) config.signal = signal;
            return this.callApi('post', url, data, [], showToast, config);
        },
        convertToFormData(object) {
            const form = new FormData();
            for (const key in object) {
                form.append(key, object[key]);
            }
            return form;
        }
    },
};
